import { GoalNotSucceededError } from './GoalNotSucceedError';

export class PlanningGoalNotSucceededError extends GoalNotSucceededError {
  /**
   * Index into the plan request's `targets` of the first target whose
   * planning stage produced no solution, when the planner reported it.
   */
  public readonly failedGoalIndex?: number;

  public constructor(message: string = '', failedGoalIndex?: number) {
    super(message);
    this.failedGoalIndex = failedGoalIndex;
  }
}
